import {Business, CurrentUser} from "../../../types/Types";
import {Form} from "react-bootstrap";
import * as React from "react";
import {useState} from "react";
import {useNavigate} from "react-router";
import TextField from "../../../components/form/TextField";
import LocationSelector from "../../../components/form/LocationSelector";
import {httpsCallable} from "@firebase/functions";
import {functions} from "../../../firebase/FirebaseProvider";

interface Props {
  currentUser: CurrentUser,
  business: Business | undefined,
}

function MenuSectionCreationPage(props: Props) {
  const navigate = useNavigate();
  const [creating, setCreating] = useState<boolean>(false);

  const [location, setLocation] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  const createMenuSection = async () => {
    if(!props.business) {
      return
    }
    setCreating(true);

    const createMenuSection = httpsCallable(functions, 'createMenuSection');
    await createMenuSection({
      business: props.business.id,
      location: location,
      description: description,
    }).then(() => {
      navigate("/menu");
    });
  };

  return (
      <div>
        <Form className={"mb-3"}>
          <LocationSelector business={props.business} setValue={setLocation}/>
          <TextField label={"Description"} subLabel={"For example: Drinks"} value={description} setValue={setDescription} required={true}/>
        </Form>
        {!creating && <div className={"primary-button"} onClick={() => createMenuSection()}>Create Menu Section</div>}
        {creating && <div className={"primary-button"}>Creating...</div>}
      </div>
  );
}

export default MenuSectionCreationPage;